/**
 * Language Configuration - V2
 * Compatible with new i18n system
 */

import { env } from './environment';

export const SUPPORTED_LANGUAGES = ['de', 'en', 'es'] as const;
export type Language = typeof SUPPORTED_LANGUAGES[number];

export const LANGUAGE_NAMES: Record<Language, string> = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
};

export const LANGUAGE_FLAGS: Record<Language, string> = {
  de: '🇩🇪',
  en: '🇬🇧',
  es: '🇪🇸',
};

/**
 * Get current language from environment
 */
export function getCurrentLanguage(): Language {
  const envLang = (env.language || 'de').toLowerCase();
  
  if (SUPPORTED_LANGUAGES.includes(envLang as Language)) {
    return envLang as Language;
  }
  
  console.warn(`Invalid language: ${envLang}, falling back to 'de'`);
  return 'de';
}

/**
 * Get subdomain for a specific language
 */
export function getLanguageSubdomain(lang: Language): string {
  const subdomainMap: Record<Language, string> = {
    de: 'burnout-test',
    en: 'burnout-check',
    es: 'test-burnout',
  };
  
  return subdomainMap[lang];
}

/**
 * Get alternate language URLs for hreflang tags
 */
export function getAlternateUrls(): Record<Language, string> {
  return {
    de: `https://${getLanguageSubdomain('de')}.samebi.net`,
    en: `https://${getLanguageSubdomain('en')}.samebi.net`,
    es: `https://${getLanguageSubdomain('es')}.samebi.net`,
  };
}

